import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputChipsCst from "@components/InputCst/InpuctChipsCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../types";
import SectionHeader from "./SectionHeader";

const ReportingTagsSection: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
}) => {
  const { t } = useTranslation("wizard-activity");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <SectionHeader
        title={t("sections.reporting-tags.title")}
        description={t("sections.reporting-tags.description") || undefined}
      />
      <InputChipsCst
        id="activity-lo-tag"
        label={t("fields.reporting-tags") || ""}
        value={data.lo_tag as unknown as []}
        onAdd={(chips: string[]) => setData({ lo_tag: chips })}
        maxLength={25}
      />
    </Box>
  );
};

export default ReportingTagsSection;
